import React from 'react';

import company from '@data/company.json';

function buildLocalBusiness(imageUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: company.name,
    description: company.description,
    url: company.url,
    image: imageUrl,
    telephone: company.contact.phone,
    email: company.contact.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Karakaj 470A',
      addressLocality: 'Zvornik',
      postalCode: '75400',
      addressCountry: 'BA',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: company.contact.position[0],
      longitude: company.contact.position[1],
    },
    areaServed: [
      { '@type': 'Country', name: 'Bosna i Hercegovina' },
      { '@type': 'Country', name: 'Srbija' },
    ],
    sameAs: [
      company.contact.social.facebook.url,
      company.contact.social.instagram.url,
    ],
  };
}

function buildBreadcrumb(siteUrl, pageTitle, pagePath) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Početna', item: siteUrl + '/' },
      { '@type': 'ListItem', position: 2, name: pageTitle, item: siteUrl + pagePath },
    ],
  };
}

const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

const StructuredData = ({ siteUrl, ogImageUrl, pageTitle, pagePath }) => (
  <>
    <JsonLd data={buildLocalBusiness(ogImageUrl)} />
    {pagePath && pagePath !== '/' && (
      <JsonLd data={buildBreadcrumb(siteUrl, pageTitle, pagePath)} />
    )}
  </>
);

export default StructuredData;
